import React from 'react'
import PropTypes from 'prop-types'
import { sanitizeProps } from '@fs/zion-frontend-friends'
import RadioGroup from '../radio-group'

export default function CheckboxGroup({ children, ...props }) {
  return <RadioGroup {...sanitizeProps(props)}>{children}</RadioGroup>
}

CheckboxGroup.propTypes = {
  /** Label text for the group of inputs.  JSX is allowed, but please don't use for anything except links. */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),

  /** Increases label size when set to true */
  largerLabel: PropTypes.bool,

  /** Determines the direction the inputs are layed out. */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),

  /** Disables the entire radio group if true. */
  disabled: PropTypes.bool,

  /** Valid message text. */
  validMessage: PropTypes.string,

  /** Error message text. */
  errorMessage: PropTypes.node,

  /** Help message text. */
  helpMessage: PropTypes.node,

  /** Function that runs to check if a warning should be displayed. Must return a string or null. */
  warningValidate: PropTypes.func,
}
